import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    key: string;
    value: string;
}>;

/** Dispatches a Dynamic Form field value into Redux. */
export const DispatchSetFieldValue: HandlerType = props => {
    props.dispatch({
        type: "Components/DynamicForm/SetFieldValue",
        key: props.parameter.key,
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetFieldValue];

const setDynamicFormFieldValue = createHandlerChainRunner(chain, "SetDynamicFormFieldValue");
export default setDynamicFormFieldValue;
